import { Screen } from '@tempmee/react';
import { CenteredSpinner } from '~/commonComponents';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FilterStatusEnum, FilterStatusLabel } from '~/utils/Enum';
import { GET_ALL_JOBS_ACTION, changeSchedule } from '../../actions';
import { createLoadingSelector } from '../../api/selectors';
import { ButtonGroup, InputSelect } from '../../commonComponents';

import { Calendar } from './components/Calendar/Calendar';
import { CalendarLegends } from './components/Calendar/Legends';
import { JobList } from './components/JobList/JobList';
import { MonthSelection } from './components/MonthSelection/MonthSelection';
import calendarIconSVG from '../../images/calendar-outline.svg';
import allIconSVG from '../../images/receipts-all-icon.svg';

const loadingSelector = createLoadingSelector([GET_ALL_JOBS_ACTION]);

export const Schedule = () => {
  const dispatch = useDispatch();
  const schedule = useSelector((state) => state.job.schedule);
  const isLoading = useSelector((state) => loadingSelector(state));
  const [viewType, setViewType] = useState(schedule.view);
  const [statusFilter, setStatusFilter] = useState(schedule.filter);

  const handleFilterChange = (value) => {
    setStatusFilter(value);
    dispatch(changeSchedule({ payload: { option: 'filter', value } }));
  };

  const handleViewType = (value) => {
    setViewType(value);
    dispatch(changeSchedule({ payload: { option: 'view', value } }));
  };

  return (
    <Screen variant="detached-header">
      <Screen.Header title="Schedule">
        <div
          style={{
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          {viewType === 'calendar' && (
            <div>
              <MonthSelection />
            </div>
          )}
          {viewType === 'calendar' && isLoading && (
            <div
              style={{
                display: 'flex',
                flex: 1,
                justifyContent: 'center',
              }}
            >
              <CenteredSpinner />
            </div>
          )}
          <div
            style={{
              display: 'flex',
              flex: 1,
              justifyContent: 'flex-end',
              gap: 24,
            }}
          >
            <div
              style={{
                width: 230,
              }}
            >
              <InputSelect
                value={statusFilter}
                setValue={handleFilterChange}
                isSelectVisible={false}
                options={[
                  FilterStatusEnum.ALL,
                  FilterStatusEnum.TODAY,
                  FilterStatusEnum.PENDING_COUNTER,
                  FilterStatusEnum.SCHEDULED,
                  FilterStatusEnum.OPEN,
                  FilterStatusEnum.COMPLETED,
                  FilterStatusEnum.CANCELLED_OR_EXPIRED,
                ].map((value) => ({ title: FilterStatusLabel[value], value }))}
              />
            </div>
            <ButtonGroup
              value={viewType}
              options={[
                { value: 'calendar', src: calendarIconSVG },
                { value: 'list', src: allIconSVG },
              ]}
              onClick={handleViewType}
            />
          </div>
        </div>
      </Screen.Header>
      <Screen.Body>
        {viewType === 'list' && (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              width: '100%',
              height: '100%',
              alignItems: 'center',
            }}
          >
            <JobList status={statusFilter} />
          </div>
        )}

        {viewType === 'calendar' && (
          <div style={{ width: '100%', marginBottom: 12 }}>
            <Calendar status={statusFilter} />
            <CalendarLegends />
          </div>
        )}
      </Screen.Body>
    </Screen>
  );
};
